import { DatePicker } from 'antd';
import dayjs from 'dayjs';

import type { FieldControlProps } from '../../../components/ui/Field';

/**
 * Ô chọn một ngày cho hộp cấp thêm token và yêu cầu (ADR-0091): giá trị là chuỗi `YYYY-MM-DD` (đúng kiểu
 * `date` của API), hiện `dd/MM/yyyy` ở cả hai ngôn ngữ như mọi ngày khác của giao diện. `tu`, `den` khoá
 * ngày ngoài khoảng ngay trên lịch; kiểm thật vẫn ở `nghiep-vu/cap-them-token.ts` và ở server.
 */
export function ONgayTrongKhoang({
  p,
  value,
  onChange,
  tu,
  den,
  placeholder,
}: {
  p: FieldControlProps;
  value: string;
  onChange: (v: string) => void;
  tu?: string;
  den?: string;
  placeholder?: string;
}) {
  return (
    <DatePicker
      {...p}
      className="w-full"
      status={p['aria-invalid'] ? 'error' : undefined}
      format="DD/MM/YYYY"
      placeholder={placeholder}
      value={value ? dayjs(value) : null}
      onChange={(d) => onChange(d ? d.format('YYYY-MM-DD') : '')}
      disabledDate={(d) => (tu ? d.isBefore(dayjs(tu), 'day') : false) || (den ? d.isAfter(dayjs(den), 'day') : false)}
    />
  );
}
